// extracted by mini-css-extract-plugin
export var previewContainer = "_sv-0";